import { LoadSelectionScopeReason } from './assets.repository';
import { LicenseUser } from '../../models/license-user';
import { LicenseProduct } from '../../models/license-product';
import { FilterAssetsSelectOption } from '../../features/assets/components/filter-assets-dropdown/models/filter-assets-select-option';
import { actionsFactory, props } from '@ngneat/effects';
import { UserImport } from '@tmx/data-access';

const assetsActions = actionsFactory('assets');

export const loadAssets = assetsActions.create('Load Assets');

export const loadFleetData = assetsActions.create(
  'Load Fleet Data',
  props<{ externalIds: string[] }>()
);

export const reloadAssets = assetsActions.create('Reload Assets');

export const setAssetsOffset = assetsActions.create(
  'Set Assets Offset',
  props<{ offset: number }>()
);

export const setAssetsSort = assetsActions.create(
  'Set Assets Sort Properties',
  props<{ sortExpression: string; sortDirection: '' | 'asc' | 'desc' }>()
);

export const setAssetsQuery = assetsActions.create(
  'Set Assets Query',
  props<{ query: string }>()
);

export const setFilterAssetsSelectOption = assetsActions.create(
  'Set Filter Assets Select Option',
  props<{ filterAssetsSelectOption: FilterAssetsSelectOption | null }>()
);

export const selectAsset = assetsActions.create(
  'Select Asset',
  props<{ checked: boolean; asset: LicenseUser }>()
);

export const importAssets = assetsActions.create(
  'Import List Of Assets',
  props<{ assets: UserImport[] }>()
);

export const clearImportResponse = assetsActions.create(
  'Clear Import Response'
);

export const selectAllAssets = assetsActions.create(
  'Select All Assets',
  props<{ checked: boolean }>()
);

export const refreshAssetsRowsDescriptor = assetsActions.create(
  'Refresh Assets Rows Descriptor'
);

export const clearSelectedAssets = assetsActions.create(
  'Clear Selected Assets'
);

export const setVehiclesHistoryRowsDescriptor = assetsActions.create(
  'Set Vehicles History Rows Descriptor To Loading Or Use Current Vehicles History Data',
  props<{ loading: boolean }>()
);

export const loadUsersCsv = assetsActions.create('Load Users Csv File');

export const clearAssets = assetsActions.create('Clear Assets');

export const loadSelectionScope = assetsActions.create(
  'Load Selection Scope',
  props<{ reason: LoadSelectionScopeReason }>()
);

export const loadHistoricalVehicles = assetsActions.create(
  'Load Vehicle History',
  props<{ assetId: string }>()
);

export const setHistoricalVehiclesOffset = assetsActions.create(
  'Set Historical Vehicles Offset',
  props<{ offset: number }>()
);

export const setFilterByAssetIds = assetsActions.create(
  'Set Filter By Asset Ids',
  props<{ filterByAssetIds: string[] }>()
);

export const cancelFilterByAssetsImport = assetsActions.create(
  'Cancel Filter By Assets Import'
);

export const loadHistoricalNotifications = assetsActions.create(
  'Load Historical Notifications',
  props<{ externalId: string }>()
);

export const inviteSamsaraUser = assetsActions.create(
  'Invite Samsara User To Product',
  props<{ asset: LicenseUser; product: LicenseProduct }>()
);

export const inviteSamsaraUsers = assetsActions.create(
  'Invite Samsara Users To All Products Associated With Their Asset',
  props<{ assets: LicenseUser[] }>()
);

export const checkIfAssetIsDeleted = assetsActions.create(
  'Check If Asset Is Deleted',
  props<{ externalId: string }>()
);

export const checkIfAssetIsCreated = assetsActions.create(
  'Check If Asset Is Created',
  props<{ externalId: string }>()
);

export const checkIfAssetIsChanged = assetsActions.create(
  'Check If Asset Is Changed',
  props<{ externalId: string; asset: LicenseUser }>()
);

export const loadCopilotVersions = assetsActions.create(
  'Load CoPilot Versions'
);
